<div class="wrapper">
  <app-header title="{{ 'CLIENT_PROFILE.HEADER.TITLE' | translate }}"> </app-header>
  <div class="flex menu">
    <button
      mat-flat-button
      disableRipple
      [class.selected]="tab === 'bank-account-edit'"
      (click)="tab = 'bank-account-edit'"
    >
      {{ "CLIENT_PROFILE.MENU.BANK_ACCOUNT" | translate }}
    </button>
    <button
      mat-flat-button
      disableRipple
      [class.selected]="tab === 'user-options'"
      (click)="tab = 'user-options'"
    >
    {{ "CLIENT_PROFILE.MENU.TOV" | translate }}
    </button>
    <button
      mat-flat-button
      disableRipple
      [class.selected]="tab === 'api-integrations'"
      (click)="tab = 'api-integrations'"
    >
    {{ "CLIENT_PROFILE.MENU.INTEGRATIONS" | translate }}
    </button>
  </div>
  <div class="flex content column">
    <app-bank-account-edit
      *ngIf="tab === 'bank-account-edit'"
    ></app-bank-account-edit>
    <app-client-options *ngIf="tab === 'user-options'"></app-client-options>
    <app-api-integrations
      *ngIf="tab === 'api-integrations'"
    ></app-api-integrations>
  </div>
</div>
